module.exports = __webpack_public_path__ + "static/img/cabinet24_7.7fe621f6.gif";